import React, { useEffect, useState, useRef } from 'react';
import styles from "../../assets/stylesheets/sass/Navigation.module.scss";
import stylesCheckbox from "../../assets/stylesheets/sass/Checkbox.module.scss";

export default function Checkbox({data, type, size, onChange, value}){
    
    const [checkedItems, setcheckedItems] = useState({});

    useEffect(()=>{
        if(data.length > 0 && type === "filled"){
            let tmpObject = {};
            let keys = Object.keys(data);
            for (let i = 0; i < keys.length; i++) {
                tmpObject[keys[i]] = true;
            }
            setcheckedItems(tmpObject);
        }
    }, [data])

    const handleChangeInput = (e) =>{
            let state = e.currentTarget.checked;
            
            onChange(state);
        
            let tmpObject = {...checkedItems};

            tmpObject[e.currentTarget.id] = !tmpObject[e.currentTarget.id];

            setcheckedItems(tmpObject);
    }

  return (
      <>
        {type === "filled" ? 
        <ul className={styles.ks_cboxtags}>
            {data.length > 0 && data.map((v, i)=>{
                return (
                <li key={i}>
                    <input value={v} type="checkbox" id={"filled"+i} onChange={(e)=>{handleChangeInput(e)}} checked={checkedItems[v] ? checkedItems[v] : false}/>
                    <label htmlFor={"filled"+i}>{v}</label>
                </li>
                )
            })}
        </ul>
        :
        (
            data.length > 0 && data.map((v, i)=>{
                return (
                    <div className={size === "small" ? stylesCheckbox.form_groupSMALL : stylesCheckbox.form_group} key={i}>
                        <input checked={checkedItems["standard"+i] ? checkedItems["standard"+i] : value ? value : false} type="checkbox" id={"standard"+i} onChange={(e)=>handleChangeInput(e)}/>
                        <label htmlFor={"standard"+i}>{v}</label>
                    </div>
                )
            })
        )
        }
      </>
  )
}